import React, { useEffect, useState } from 'react'
import SummaryApi from '../common'
import { toast } from 'react-toastify'
import moment from 'moment'
import { MdModeEdit } from "react-icons/md";
import ChangeUserRole from '../components/ChangeUserRole';

const AllCustomers = () => {
    const [allUser, setAllUsers] = useState([])
    const [openUpdateRole, setOpenUpdateRole] = useState(false)
    const [updateUserDetails, setUpdateUserDetails] = useState({
        email: "",
        name: "",
        role: "",
        _id: ""
    })
    const [currentPage, setCurrentPage] = useState(1)
    const [usersPerPage, setUsersPerPage] = useState(10)
    const [totalUsers, setTotalUsers] = useState(0)

    const fetchAllUsers = async () => {
        const fetchData = await fetch(SummaryApi.allUser.url, {
            method: SummaryApi.allUser.method,
            headers: {
                'Authorization': 'Bearer oakyaecom_no_units_916',
                'Content-Type': 'application/json',
            },
        });
    
        const dataResponse = await fetchData.json();
        console.log(dataResponse);
        if (dataResponse.status) {
            setAllUsers(dataResponse.data);
            setTotalUsers(dataResponse.data.length); // Set total users based on the length of the data array
        }
    
        if (dataResponse.error) {
            toast.error(dataResponse.message);
        }
    };
    

    useEffect(() => {
        fetchAllUsers()
    }, [currentPage, usersPerPage])

    // Pagination Logic
    const indexOfLastUser = currentPage * usersPerPage
    const indexOfFirstUser = indexOfLastUser - usersPerPage
    const currentUsers = allUser.slice(indexOfFirstUser, indexOfLastUser)

    const paginate = (pageNumber) => setCurrentPage(pageNumber)
    const goToFirstPage = () => setCurrentPage(1)
    const goToLastPage = () => setCurrentPage(Math.ceil(totalUsers / usersPerPage))
    const goToPreviousPage = () => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)
    const goToNextPage = () => setCurrentPage(currentPage < Math.ceil(totalUsers / usersPerPage) ? currentPage + 1 : currentPage)

    const changeRecordsPerPage = (recordsPerPage) => {
        setUsersPerPage(recordsPerPage)
        setCurrentPage(1)  // Reset to first page
    }

    // Calculate range for current page
    const startIndex = (currentPage - 1) * usersPerPage + 1
    const endIndex = Math.min(currentPage * usersPerPage, totalUsers)

    return (
        <div className='bg-white pb-4'>
            {/* Table Header */}
            <div className='flex justify-between items-center'>
                <h2 className='font-bold text-lg text-black m-3'>All Customers</h2>
                <span className='text-gray-800'>Total Records: {totalUsers}</span>
            </div>

            {/* Table */}
                <table className='w-full userTable m-3'>
                    <thead className='bg-blue-500 text-white'>
                        <tr>
                            <th className='text-center px-4 py-2'>S.NO</th>
                            <th className='text-center px-4 py-2'>Full Name</th>
                            <th className='text-center px-4 py-2'>Email Address</th>
                            <th className='text-center px-4 py-2'>Mobile Number</th>
                            <th className='text-center px-4 py-2'>Date Created</th>
                            <th className='text-center px-4 py-2'>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentUsers.map((el, index) => {
                                return (
                                    <tr key={el._id} className='border-b'>
                                        <td className='text-center px-4 py-2'>{index + 1}</td>
                                        <td className='text-center px-4 py-2'>{el?.full_name}</td>
                                        <td className='text-center px-4 py-2'>{el?.email}</td>
                                        <td className='text-center px-4 py-2'>{el?.mobile_number}</td>
                                        <td className='text-center px-4 py-2'>{moment(el?.created_date).format('LL')}</td>
                                        <td className='text-center px-4 py-2'>
    <span className={`px-2 py-1 rounded-full text-sm ${el?.is_active === "1" ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
        {el?.is_active === 1 ? 'Active' : 'Inactive'}
    </span>
</td>

                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>


            {/* Pagination Footer */}
       {/* Pagination Footer */}
<div className='bg-blue-500 text-white py-1 m-2'>
    <div className='flex justify-between items-center px-4'>
        {/* Total Records */}
        <div className='text-white'>
            <span>Total Records: {totalUsers}</span>
        </div>

        {/* Pagination Buttons */}
    {/* Pagination Buttons */}
{/* Pagination Buttons */}
{/* Pagination Buttons */}
<div className='flex items-center'>
    <button 
        className={`mx-1 p-1 rounded ${currentPage === 1 ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-yellow-500 text-white cursor-pointer'}`}
        onClick={goToFirstPage}
        disabled={currentPage === 1}
    >
        &lt;&lt; First
    </button>
    <button 
        className={`mx-1 p-1 rounded ${currentPage === 1 ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-red-500 text-white cursor-pointer'}`}
        onClick={goToPreviousPage}
        disabled={currentPage === 1}
    >
        &lt; Previous
    </button>

    <button 
        className={`mx-1 p-1 rounded ${currentPage === Math.ceil(totalUsers / usersPerPage) ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-green-500 text-white cursor-pointer'}`}
        onClick={goToNextPage}
        disabled={currentPage === Math.ceil(totalUsers / usersPerPage)}
    >
        Next &gt;
    </button>
    <button 
        className={`mx-1 p-1 rounded ${currentPage === Math.ceil(totalUsers / usersPerPage) ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-purple-500 text-white cursor-pointer'}`}
        onClick={goToLastPage}
        disabled={currentPage === Math.ceil(totalUsers / usersPerPage)}
    >
        Last &gt;&gt;
    </button>
</div>




        {/* Records per page */}
        <div className='flex items-center'>
            <span className='mr-2'>Show</span>
            <select
                className='p-2 bg-gray-800 text-white'
                value={usersPerPage}
                onChange={(e) => changeRecordsPerPage(Number(e.target.value))}
            >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
            </select>
        </div>
    </div>
</div>

            {/* Change User Role Modal */}
            {
                openUpdateRole && (
                    <ChangeUserRole
                        onClose={() => setOpenUpdateRole(false)}
                        name={updateUserDetails.full_name}
                        email={updateUserDetails.email}
                        role={updateUserDetails.role}
                        userId={updateUserDetails.customer_id}
                        callFunc={fetchAllUsers}
                    />
                )
            }
        </div>
    )
}

export default AllCustomers
